import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import {
  fetchItems,
  updateItem,
  INotificationAttributes
} from '@/api/notifications'
import { ElMessage } from 'element-plus'

const predefinedContent = (content: string): string => {
  switch (content) {
    case 'replenishment_voided':
      return 'Your invoice was expired. <br> In the case you still want to make a payment, please request the new one on the section Payment. <br> In case you have already paid the current invoice, please let us know via LifeChat or email support@traforama.com'
    case 'replenishment_completed':
      return 'Your replenishment request completed!'
    case 'paypal_rejected':
      return 'The payment was rejected because of PayPal account or country mismatch. <br> Please contact us via Live chat or email to <a href="mailto:support@traforama.com">support@traforama.com</a>'
    default:
      return content
  }
}

export const useNotificationStore = defineStore('notification', () => {
  // State
  const notification = ref<INotificationAttributes | null>(null)

  // Actions
  const setItem = (newNotification: INotificationAttributes) => {
    notification.value = newNotification
  }

  const setPublished = (value: boolean) => {
    if (notification.value) {
      notification.value.published = value
    }
  }

  const fetchNotification = async () => {
    const response = await fetchItems()
    const fetchedNotification = response.data[0]
    if (fetchedNotification) {
      setItem(fetchedNotification.attributes)
    } else {
      setItem({} as INotificationAttributes)
    }
  }

  const hideNotification = async () => {
    setPublished(true)
    if (notification.value) {
      await updateItem(notification.value)
    }
  }

  const ShowNotification = async () => {
    await fetchNotification()
    if (notificationPresent.value) {
      const currentNotification = notification.value
      if (!currentNotification) {
        return
      }
      ElMessage.error({
        message: predefinedContent(currentNotification.content),
        showClose: true,
        duration: 0,
        customClass: 'user-notification',
        dangerouslyUseHTMLString: true,
        onClose: () => {
          hideNotification()
        }
      })
    }
  }

  // Getters
  const notificationPresent = computed(
    () =>
      notification.value !== null && Object.keys(notification.value).length > 0
  )

  return {
    ShowNotification
  }
})
